(()=>{
if(window.__hrUpnovaI18nV3)return;window.__hrUpnovaI18nV3=1;
const lang=(document.documentElement.lang||'').toLowerCase();
const I=lang.startsWith('it')?0:lang.startsWith('es')?1:lang.startsWith('de')?2:lang.startsWith('pt')?3:-1;
if(I<0)return;

const oneMore=[
 'AGGIUNGI UN ALTRO ARTICOLO, RICEVINE UN ALTRO GRATIS',
 'AÑADE UN ARTÍCULO MÁS Y RECIBE OTRO GRATIS',
 'EINEN WEITEREN ARTIKEL HINZUFÜGEN UND EINEN WEITEREN GRATIS ERHALTEN',
 'ADICIONE MAIS UM ARTIGO E RECEBA OUTRO GRÁTIS'
][I];

function promo(n,m){return [
 `Compra ${n} gioielli e ricevine ${m} gratis`,
 `Compra ${n} joyas y llévate ${m} gratis`,
 `${n} Schmuckstücke kaufen, ${m} gratis`,
 `Compre ${n} peças de joalharia e receba ${m} grátis`
][I];}
function addMore(n){return [
 `Aggiungi ancora ${n} articolo${String(n)==='1'?'':'i'} per riceverne uno gratis`,
 `Añade ${n} artículo${String(n)==='1'?'':'s'} más para recibir uno gratis`,
 `Füge noch ${n} Artikel hinzu, um einen gratis zu erhalten`,
 `Adicione mais ${n} artigo${String(n)==='1'?'':'s'} para receber um grátis`
][I];}
function tr(s){
 if(typeof s!=='string'||!s.trim())return s;
 const lead=(s.match(/^\s*/)||[''])[0],trail=(s.match(/\s*$/)||[''])[0];
 const k=String(s).replace(/\s+/g,' ').trim();
 let v=null,m;
 if(/^buy\s+one\s+more\s+item\s*,?\s*get\s+one\s+more\s+free!?$/i.test(k))v=oneMore;
 if(!v){
  m=k.match(/^buy\s+(\d+)\s+(?:jewelry|jewellery|jewerly)\s*(?:[-–—,:]\s*|\s+and\s+|\s+)?get\s+(\d+)\s+(?:free|gratis|fratis)!?$/i);
  if(m)v=promo(m[1],m[2]);
 }
 if(!v){
  m=k.match(/^add\s+(\d+|one)\s+more(?:\s+(?:item|items|product|products))?\s+to\s+(?:get|unlock)\s+(?:(?:a|one|1)\s+)?free(?:\s+(?:gift|item|free))?!?$/i);
  if(m)v=addMore(String(m[1]).toLowerCase()==='one'?'1':m[1]);
 }
 return v?lead+v+trail:s;
}

const roots=new WeakSet();
function apply(n){
 if(!n)return;
 if(n.nodeType===3){
  const p=n.parentElement;if(!p||p.closest('script,style,noscript,template'))return;
  const z=tr(n.nodeValue);if(z!==n.nodeValue)n.nodeValue=z;return;
 }
 if(n.nodeType!==1||n.matches('script,style,noscript,template'))return;
 ['aria-label','title','placeholder'].forEach(a=>{if(n.hasAttribute(a)){const v=n.getAttribute(a),z=tr(v);if(z!==v)n.setAttribute(a,z);}});
}
function walk(r){if(!r)return;apply(r);const w=document.createTreeWalker(r,NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_TEXT);let n;while(n=w.nextNode())apply(n);}
function observe(r){
 if(!r||roots.has(r))return;roots.add(r);walk(r);
 try{new MutationObserver(ms=>ms.forEach(m=>{
  if(m.type==='characterData')apply(m.target);
  if(m.type==='attributes')apply(m.target);
  m.addedNodes.forEach(n=>{apply(n);if(n.nodeType===1||n.nodeType===11){walk(n);n.querySelectorAll?.('*').forEach(e=>e.shadowRoot&&observe(e.shadowRoot));}});
 })).observe(r,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['aria-label','title','placeholder']});}catch(e){}
}
function scan(){
 (window.__hrCapturedShadowRoots||[]).forEach(observe);
 document.querySelectorAll('*').forEach(e=>e.shadowRoot&&observe(e.shadowRoot));
 document.querySelectorAll('iframe').forEach(f=>{try{f.contentDocument?.body&&observe(f.contentDocument.body)}catch(e){}});
}
window.addEventListener('hr:shadowroot',e=>observe(e.detail));
scan();setTimeout(scan,250);setTimeout(scan,900);setInterval(scan,1200);
})();